<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_amzMoqName') || '产品起定量名称'"
            prop="amzMoqName"
          >
            <el-input
              v-model="formData.amzMoqName"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="scmCode"
            :label="$l('INDEX.form_label_scm') || '工厂'"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :selectedLabel.sync="formData.scmName"
              clearable
              filterable
              size="small"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_placeholder_buyer') || '采购人员'"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.tips_select_placeholder') || '请选择采购人员'
              "
              :selectedLabel.sync="formData.buyerName"
              size="small"
              filterable
              clearable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_moq_unit') || '起定量单位'"
            prop="moqUnit"
          >
            <dict-select
              v-model="formData.moqUnit"
              url="/master/common/dict/biz"
              :body="moqUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="small"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapState } from 'vuex'
export default {
  mixins: [EditLoading],
  props: { disabled: Boolean },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.buyerCode = this.formData.buyerCode || ''
        if (
          userCode &&
          !this.formData.buyerCode != userCode &&
          !this.disabled
        ) {
          this.formData.buyerCode = userCode
          this.formData.buyerName = `${userNameEn}-${userName}`
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      formData: {
        buyerCode: '',
        buyerName: '',
      },
      moqUnitParams: { dictType: 'amzMoqUnit' },
      rules: {
        amzMoqName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        moqUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {},
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.$confirm(
        this.$l('INDEX.tips_add_save') ||
          '起定量单位保存后不能更改，是否确认保存?',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomAmzMoqSaveApi(this.formData)
          .then(async (res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.close()
            this.openEditPage({
              pageType: 'edit',
              params: { code: res.body.amzMoqCode },
              query: { amzMoqNo: res.body.amzMoqNo },
            })
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          })
      })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-awsMoqSet-detail',
        params: { ...params, pageType },
        query,
      })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
